// extracted by mini-css-extract-plugin
export default {"inscription":"mediatheque_inscription__ptlux"};